module.exports = __webpack_public_path__ + "img/onlineCarbg2.a62df3aa.png";